jQuery.fn.extend({
  easLock: function (flag) {
    return this.each(function () {
      $(this).toggleClass("locked", flag)
    })
  },
})
